import api, { request } from '../../../../../../../api';
import { isError } from '../../../../../../../contrib/Utils/isError';
import { ICombination, IStateDispatchActions } from '../AssignResults.context';

export type ISetCombinations = (clubId: number, eventId: number, roundId?: number) => void;

export const setCombinations: IStateDispatchActions<ISetCombinations> = (state, dispatch) => async (
  clubId,
  eventId,
  roundId
) => {
  const { eventFormatsList, flights, roundFormatsList } = state;

  const response = roundId
    ? await request.get(api.admin.roundLeaderboards(clubId, eventId, roundId))
    : await request.get(api.admin.eventLeaderboards(clubId, eventId));

  if (isError(response)) {
    throw new Error(response.error);
  }

  const combinationFormatsList = roundId ? roundFormatsList : eventFormatsList;

  const combinations = response.map(
    ({ flight: flightId, format: formatId, ...rest }: ICombination) => {
      const format = combinationFormatsList[Number(formatId)];

      if (!format) {
        return [];
      }

      return {
        flight: flights[Number(flightId)],
        format: {
          ...format,
          format: { ...format.format, prefix: format.format.prefix.replace('_', '') }
        },
        ...rest
      };
    }
  );

  dispatch({
    type: 'setCombinations',
    value: combinations
  });
};
